import { IAnimationElementProps } from '../common/Animation';

export const subheaderAnimationConfig: IAnimationElementProps = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { type: 'spring', duration: 0.7 },
};
